module.exports = __webpack_public_path__ + "static/media/odbijeno.0d713fa9.svg";